import React from 'react';
import PropTypes from 'prop-types';
import TextNodeContainer from './text-node';
import VideoNode from './video-node';
import ImageNode from './image-node';
import AudioNodeContainer from './audio-node';


const getDataFromNode = function(node) {
    return ['id', 'title'].reduce((data, key) => {
        return {...data, [key]: node.attr[key]};
    }, {});
};

class IntervalNode extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ...getDataFromNode(this.props.node),
        };
        this.getListItems = this.getListItems.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.node !== nextProps.node) {
            this.setState({
                ...getDataFromNode(nextProps.node)
            });
        }
        // React will not trigger a re-play of the audio when the component is re-rendered so we have to invoke play manually.
        if (this.audioRef) {
            this.audioRef.audio.play();
        }
        if (this.videoRef) {
            this.videoRef.video.play();
        }
    }

    getListItems(node) {
        const {moduleURL = '', disableJREAppPlayerContainerButtons, enableJREAppPlayerContainerButtons} = this.props;

        return node.children.map(n => {
            switch (n.name) {
                case 'text_node':
                    return <TextNodeContainer key={n.attr.id} node={n} />;
                case 'button_node':
                    return <ButtonNode moduleURL={moduleURL} key={n.attr.id} node={n} />;
                case 'image_node':
                    return <ImageNode moduleURL={moduleURL} key={n.attr.id} node={n} />;
                case 'slideshow_node':
                    return <SlideshowNode moduleURL={moduleURL} key={n.attr.id} node={n}/>;
                case 'audio_node':
                    return <AudioNodeContainer moduleURL={moduleURL} ref={(audio) => { this.audioRef=audio; }}
                                               key={n.attr.id} node={n}
                                               enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                                               disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />;
                case 'video_node':
                    return <VideoNode moduleURL={moduleURL} ref={(video) => { this.videoRef=video; }}
                                      key={n.attr.id} node={n}
                                      enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                                      disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />;
                default:
                    return null;
            }
        });
    }

    render() {
        return (
            <div className="interval-node">
                <div>
                    {this.getListItems(this.props.node)}
                </div>
            </div>
        );
    }
}

IntervalNode.propTypes = {
    node: PropTypes.object.isRequired,
    moduleURL: PropTypes.string,
};

export default IntervalNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/interval-node.js